import Big from 'big.js'
import * as R from 'ramda'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const state = {
  chemicalItems: {}
}

const mutations = {
  LOAD_CHEMICAL_ITEMS (state, payload) {
    state.chemicalItems = payload
  },

  UPDATE_CHEMICAL_ITEM (state, { id, item }) {
    state.chemicalItems[id] = item
  },

  ADD_CHEMICAL_ITEM (state, { id, item }) {
    const items = {
      ...state.chemicalItems,
      [id]: item
    }
    state.chemicalItems = items
  },

  DELETE_CHEMICAL_ITEM (state, payload) {
    state.chemicalItems = R.omit(payload, state.chemicalItems)
  }

}

const actions = {
  updateChemicalItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createChemical(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_CHEMICAL_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved for this browser session'
        commit('ADD_CHEMICAL_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateChemical(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            commit('UPDATE_CHEMICAL_ITEM', jsConn.formParams)
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.apiParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        commit('UPDATE_CHEMICAL_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated for this browser session'
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteChemicalItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteChemical(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          // delete it from any crops
          dispatch('deleteChemicalItemFromAllCrops', jsConn)
          commit('DELETE_CHEMICAL_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Chemical item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteChemicalItemFromAllCrops', jsConn)
      commit('DELETE_CHEMICAL_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  chemicalItems: state => state.chemicalItems,

  chemicalItemsIdList: state => {
    return Object.keys(state.chemicalItems)
  },

  chemicalItemsList: (state, getters, rootState, rootGetters) => {
    const itemsList = getters.chemicalItemsIdList.map((id) => {
      const item = getters.getChemicalItemById(id)
      const convertUnit = rootGetters.getConvertUnitItemById(item.convertUnitId)

      return {
        id: id,
        description: item.description,
        cost: item.cost,
        fromUnit: convertUnit.fromUnit,
        toUnit: convertUnit.toUnit,
        defaultApplicationRate: item.defaultApplicationRate,
        appliedCost: new Big(item.cost).div(convertUnit.quantity).toFixed(4)
      }
    })

    return itemsList
  },

  getChemicalItemById: (state) => (id) => {
    return state.chemicalItems[id]
  }
}

const chemicalModule = {
  state,
  mutations,
  actions,
  getters
}

export default chemicalModule
